import React from "react";

export default function LateReasonDialog({ show, onClose, lateReason }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-lg">
        <div className="space-y-1 pb-4">
          <h3 className="text-lg font-semibold text-zinc-800">Late Reason:</h3>

          <p className="text-sm text-zinc-800 whitespace-pre-wrap">
            {lateReason || "No reason provided"}
          </p>
        </div>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded bg-zinc-900 text-white hover:bg-zinc-800 transition-colors text-sm"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
